import React from 'react';
import getFormattedNumber from 'store/redux/utils/getFormattedNumber';
import { NameDefinition } from 'components/NameDefinition';

export const TrafficReportingOverviewMetrics = [
  {
    title: (
      <NameDefinition
        name='Unique Sessions'
        definiton='Number of distinct sessions started by users.'
      />
    ),
    key: 'unique_sessions',
    format: (val) => getFormattedNumber(val),
  },
  {
    title: (
      <NameDefinition
        name='Page Views per Session'
        definiton='Average number of pages viewed during a single session.  total page views ÷ total sessions.'
      />
    ),
    key: 'page_views_per_session',
    format: (val) => getFormattedNumber(val),
  },
  {
    title: <NameDefinition name='Page Views' definiton='Total number of pages viewed.' />,
    key: 'page_views',
    format: (val) => getFormattedNumber(val),
  },
  {
    title: (
      <NameDefinition
        name='Bounce Rate'
        definiton='Percentage of sessions with only one page view, calculated as (single-page sessions ÷ total sessions) × 100.'
      />
    ),
    key: 'bounce_rate',
    format: (val) => `${getFormattedNumber(val)}%`,
  },
];
